export default __webpack_public_path__ + "static/media/help-popover-icon.ee8c2565.svg";